/** Default home carousel section order (matches HomeView render order). */
export const DEFAULT_HOME_SECTION_ORDER = [
  'my_stations',
  'recently_played',
  'favorites',
  'picked_for_you',
  'new_releases',
  'editors_picks',
  'featured_playlists',
  'popular_genre',
];

export const KNOWN_HOME_SECTION_IDS = DEFAULT_HOME_SECTION_ORDER;
